import type { PublicClientApplication } from "@azure/msal-browser";

let _instance: PublicClientApplication | null = null;

export function setMsalInstance(inst: PublicClientApplication) {
  _instance = inst;
}

export function getMsalInstance(): PublicClientApplication | null {
  return _instance;
}
